/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PosTabStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Canceled = 'CANCELED'
}
